var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6081 6.66732H11.7747V5.00065C11.7747 2.70065 9.90807 0.833984 7.60807 0.833984C5.30807 0.833984 3.44141 2.70065 3.44141 5.00065V6.66732H2.60807C1.69141 6.66732 0.941406 7.41732 0.941406 8.33398V16.6673C0.941406 17.584 1.69141 18.334 2.60807 18.334H12.6081C13.5247 18.334 14.2747 17.584 14.2747 16.6673V8.33398C14.2747 7.41732 13.5247 6.66732 12.6081 6.66732ZM5.10807 5.00065C5.10807 3.61732 6.22474 2.50065 7.60807 2.50065C8.99141 2.50065 10.1081 3.61732 10.1081 5.00065V6.66732H5.10807V5.00065ZM12.6081 16.6673H2.60807V8.33398H12.6081V16.6673ZM7.60807 14.1673C8.52474 14.1673 9.27474 13.4173 9.27474 12.5007C9.27474 11.584 8.52474 10.834 7.60807 10.834C6.69141 10.834 5.94141 11.584 5.94141 12.5007C5.94141 13.4173 6.69141 14.1673 7.60807 14.1673Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDoc);
export default __webpack_public_path__ + "static/media/lockDoc.8278267383f119a58c7385b0e8481a87.svg";
export { ForwardRef as ReactComponent };